import script from "./DueDiligence.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDiligence.vue?vue&type=script&setup=true&lang=js"

import "./DueDiligence.vue?vue&type=style&index=0&id=0914023f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0914023f"]])

export default __exports__